import React from "react"
import { graphql } from "gatsby"
import Seo from "gatsby-plugin-wpgraphql-seo"
import { Helmet } from "react-helmet"
import BannerProyectos from "../components/templates/Proyectos/BannerProyectos"
import SectionProyectos from "../components/templates/Proyectos/SectionProyectos"
import LayoutGeneral from "../components/organisms/Layout/LayoutGeneral"
import getUri from "../helper/getUri"

export const query = graphql`
  query ($id: ID!) {
    wordpress {
      page(id: $id, idType: DATABASE_ID) {
        title
        uri
        seo {
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphTitle
          opengraphDescription
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          canonical
          cornerstone
          schema {
            articleType
            pageType
            raw
          }
        }
        template {
          ... on Wordpress_Template_Proyectos {
            proyectos {
              ...bannerProyectos
            }
          }
        }
      }
    }
  }
`

export default function Proyectos({ data, location }) {
  // if(typeof window !== "undefined"){
  //   let bodyHtml = document.querySelector("body");
  //   bodyHtml.classList.remove("no-scroll");
  // }

  const page = data?.wordpress?.page
  const template = page?.template?.proyectos
  return (
    <LayoutGeneral>
      <Helmet>
        <link rel="canonical" href={getUri(page.seo.canonical)} />
      </Helmet>
      <Seo post={page} />
      <h1 className="d-none">{page.title}</h1>

      <BannerProyectos
        colorFondo={template.colorFondoBanner}
        imagen={template.imagenBanner}
        texto={template.textoBanner}
        titulo={template.tituloBanner}
        tipoBanner={template.tipoBanner}
        imagenFondoDesktop={template.imagenFondoDesktop}
        imagenFondoMovil={template.imagenFondoMovil}
      />
      <SectionProyectos location={location} />
    </LayoutGeneral>
  )
}
